export const COLORS = {
	fgPrimary: '#F28236',
	fgSecondary: '#000',
	fgFooter: '#000',
	bgFooter: '#fff',
	fgCard1: '#000',
	bgCard1: '#eeeeee',
	fgCard2: '#fff',
	bgCard2: '#F28236',
};
